
import MyCheckCreditReformResult from '~/components/marketplace/my_checks/MyCheckCreditReformResult.vue'

export default {
  extends: MyCheckCreditReformResult,
  name: `MyCheckCrifResult`
}
